import { useContext, useEffect, useState } from 'react';
import LottieLight from 'react-lottie-player';
import { AppContext } from '../../state/AppContextProvider';
import { ActionType } from '../../state/GlobalState';
import { SplashScreen } from '@capacitor/splash-screen';
import { useLogger } from '../../services/LogService';

export const LottieSplash = () => {
  const [animationData, setAnimationData] = useState<any>();

  const { state, dispatch } = useContext(AppContext);

  const logger = useLogger('LottieSplash');

  useEffect(() => {
    logger.info('useEffect() []');
    import('./animation.json').then((data) => {
      logger.info('useEffect() [] import animation.json done');
      setAnimationData(data);
      setTimeout(SplashScreen.hide, 20);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    logger.info(
      `useEffect() [state.showAnimSplash] state.showAnimSplash: ${state.showAnimSplash}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.showAnimSplash]);

  const onComplete = async () => {
    logger.debug('onComplete()');
    await dispatch({ type: ActionType.ShowAnimSplash, payload: false });
  };

  const opacity = state.showAnimSplash ? 'opacity-100' : 'opacity-0';
  const zindex = state.showAnimSplash ? 'z-50' : 'z-0';

  return (
    <div
      className={`${zindex} fixed top-0 left-0 bottom-0 right-0 
      flex items-center justify-center
       bg-primary 
       transition-all duration-1000 ${opacity} delay-500`}
    >
      {animationData && (
        <div
          className={`w-96 h-96 pt-20 
        transition-opacity duration-1000 ${opacity}`}
        >
          <LottieLight
            loop={false}
            onComplete={onComplete}
            animationData={animationData}
            play
            rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
          />
        </div>
      )}
    </div>
  );
};
